import { defineMessages } from 'react-intl';

export const messages: {
	modalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultTriggerLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	modalTitle: {
		id: 'ai-mate.rovo-settings-modal.portable-rovo-settings.modal-title.non-final',
		defaultMessage: 'Sources & apps',
		description: 'Title of the Rovo Settings modal dialog',
	},
	searchPlaceholder: {
		id: 'ai-mate.rovo-settings-modal.portable-rovo-settings.search-placeholder.non-final',
		defaultMessage: 'Search settings',
		description: 'Placeholder for the search box in the Rovo Settings modal side nav',
	},
	defaultTriggerLabel: {
		id: 'ai-mate.rovo-settings-modal.portable-rovo-settings.default-trigger-label.non-final',
		defaultMessage: 'Explore all apps',
		description: 'Label for the default button that opens the Rovo Settings modal',
	},
});
